import { useAgronodKonto } from '@/contexts/AgronodKontoContext';
import { useUser } from '@/hooks/useUser';
import { getFarmName } from '@/types/auth';

/**
 * Name of the agronodkonto currently being viewed.
 *
 * Prefer this over `getFarmName(user)` anywhere the UI labels the farm whose
 * data is on screen. `getFarmName` reads `agronodKonton[0]` — the first konto
 * in the token, which is the user's own farm — so it keeps returning that name
 * after a rådgivare switches to someone else's gård. The switcher would show
 * the new farm while every heading around it still said "your" farm.
 *
 * Falls back to `getFarmName` only when no konto is selected yet (the context
 * resolves a default on mount), which mirrors the fallback the konto switcher
 * in MainLayout already used.
 *
 * @returns The selected konto's name, or null when neither source has one.
 */
export const useFarmName = (): string | null => {
  const { selectedKonto } = useAgronodKonto();
  const { user } = useUser();

  return selectedKonto?.KontoNamn ?? getFarmName(user);
};
